import React from "react";
import NewsCard from "./NewsCard";
import { newsData } from "../data/newsData";

const News = () => {
  return (
    <section className="news-section">
      <h2 className="text-center mb-3 section-title"><em>Noticias y Casos</em></h2>

            <p className="news-intro">
              <em>
              En esta sección compartimos análisis de casos reales, novedades jurídicas y hechos de 
              actualidad que reflejan el ejercicio profesional de nuestro estudio, 
              brindando información clara y relevante para nuestros clientes.
              </em>
            </p>

      <div className="news-grid">
        {newsData.map((news) => (
          <NewsCard key={news.id} {...news} />
        ))}
      </div>
    </section>
  );
};

export default News;